module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAA6UlEQVQokZ3RIUsEYRDG8d/JgXYvCmcyWC0iJ/ghxOAWF4x+AT+CwSjYNm3XIIhBBO/AYDBoEBVsgsGqbWWOFZbj9Tj2gRfmHeY/DzPTqapKUlm+gFMs4lBZPE6WzaXJsXbQwxOOUgXT4H2c4Qefs8NZvoIBHtDHc6qsK8tT+UieIBayjPNUUafa3butXUJDbOIdB/jAOraxNcEOu1htJP6a9GswdFe/ppZwHDO/JOeerjC5CPi1BRyjXLVxnscarts4B3ijLL7bOG/gMoKmc5xoFo2XFUGc6qu+b9x7VNPxv/+n00hZvMEvRyIyY5LWqYQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/group-visa/icon-recommend.png
// module id = fggB
// module chunks = 4